import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const SGridWrapper = styled.div`
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: repeat(6, 1fr);

  & > * {
    grid-column: span 2;
  }

  & > :nth-child(1) {
    grid-column: 1 / span 3;
  }

  & > :nth-child(2) {
    grid-column: 4 / span 3;
  }

  @media ${BREAKPOINTS.MD.max} {
    grid-template-columns: 1fr;

    & > * {
      grid-column: auto !important;
    }
  }
`
